import { Card } from "antd"
import React from "react"

import { LeadViewChecklist } from "../../LeadViewPage/components/LeadViewChecklist/LeadViewChecklist.tsx"
import { type LeadWorkspaceTabContext } from "../lead-workspace-tabs.tsx"
import { LeadQualificationCard } from "./LeadQualificationCard.tsx"

/**
 * Renamed from "Additional Info" to "Details" (2026-08-30) and narrowed to
 * the two fields that have no other home: Qualification & Verification and
 * the Lead Checklist. Attachments moved to its own Files tab
 * (`files/LeadFilesTab.tsx`); Internal Notes was already duplicated on
 * Overview and is not repeated here. Neither card's own logic changed —
 * only which tab renders them.
 */
function LeadDetailsTab({
  lead,
  canEdit,
  saving,
  onPatch,
  onChecklistUpdate
}: LeadWorkspaceTabContext) {
  return (
    <div
      className={"grid grid-cols-1 lg:grid-cols-2 gap-4 items-start"}
      data-testid={"lead-additional-info"}
    >
      <div className={"min-w-0"}>
        <LeadQualificationCard
          questions={lead?.qualification_questions}
          canEdit={canEdit}
          onPatch={onPatch}
        />
      </div>

      <div className={"min-w-0"}>
        <Card size={"small"} data-testid={"workspace-card-checklist"}>
          <LeadViewChecklist
            checklist={lead?.lead_checklist ?? []}
            editAllowed={canEdit}
            saving={saving}
            onUpdate={onChecklistUpdate}
          />
        </Card>
      </div>
    </div>
  )
}

export { LeadDetailsTab }
